import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

const NONE = "(none)";

export function MappingActionWidget({ prompt, sources = [], targets = [], defaults, onSend }) {
  const [mapping, setMapping] = useState(() => {
    const initial = {};
    for (const src of sources) initial[src] = defaults?.[src] ?? NONE;
    return initial;
  });
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(null);

  const handleSubmit = () => {
    const pairs = sources
      .filter((src) => mapping[src] && mapping[src] !== NONE)
      .map((src) => `${src} → ${mapping[src]}`);
    let msg = pairs.length > 0 ? `Mappings: ${pairs.join(", ")}` : "All mappings cleared";
    if (note.trim()) msg = `${msg}. Note: ${note.trim()}`;
    setSubmitted(msg);
    onSend(msg);
  };

  if (submitted) {
    return (
      <Box bg="gray.50" borderWidth="1px" borderRadius="md" p={3} my={2}>
        <Text fontSize="xs" color="gray.500" mb={1}>
          {prompt}
        </Text>
        <Text fontSize="sm">✓ {submitted}</Text>
      </Box>
    );
  }

  return (
    <Box bg="white" borderWidth="1px" borderRadius="md" p={3} my={2}>
      <Text fontSize="sm" fontWeight="medium" mb={2}>
        {prompt}
      </Text>
      <Box maxH="40vh" overflow="auto" mb={2}>
        <Table size="sm" variant="simple">
          <Thead>
            <Tr>
              <Th>Source</Th>
              <Th>→ Target</Th>
            </Tr>
          </Thead>
          <Tbody>
            {sources.map((src) => (
              <Tr key={src}>
                <Td fontFamily="mono" fontSize="xs">
                  {src}
                </Td>
                <Td>
                  <Select
                    size="sm"
                    value={mapping[src] ?? NONE}
                    onChange={(e) =>
                      setMapping((prev) => ({ ...prev, [src]: e.target.value }))
                    }
                  >
                    <option value={NONE}>{NONE}</option>
                    {targets.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </Select>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      <Input
        size="sm"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Additional notes..."
      />
      <Button mt={2} size="sm" variant="primary" onClick={handleSubmit}>
        Submit
      </Button>
    </Box>
  );
}
